module.exports = __webpack_public_path__ + "media/images/honeyfarm/farm_nine-34436fd0f1372472ee3808ee3ebc6fd2.jpg";